import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { PasswordFieldComponent } from '../../../fields/standard/password-field/password-field.component';
import { AppModule } from '../../../../modules/app.module';
import { ZorroModule } from '../../../../modules/zorro.module';
import { ThirdPartyModule } from '../../../../modules/third-party.module';
import { AngularModule } from '../../../../modules/angular.module';
import { ConfirmValidator } from '../../../../validators/confirm.validator';
import { FormSubmitButtonComponent } from '../../../ui/forms/form-submit-button/form-submit-button.component';
import { FormLinkComponent } from '../../../ui/forms/form-link/form-link.component';
import { FormBoxComponent } from '../../../ui/forms/form-box/form-box.component';
import { FormLabelComponent } from '../../../ui/forms/form-label/form-label.component';
import { HomeState, OneTimePasswordExchangeSource } from '@mira-avant/mtlibs';
import { UrlHelper } from '../../../../utils/url.helper';

@Component({
	selector: 'app-confirm-forgot-password-form',
	standalone: true,
	imports: [
		AppModule,
		ZorroModule,
		ThirdPartyModule,
		AngularModule,
		PasswordFieldComponent,
		FormSubmitButtonComponent,
		FormLinkComponent,
		FormBoxComponent,
		FormLabelComponent,
	],
	templateUrl: './confirm-forgot-password-form.component.html',
	styleUrl: './confirm-forgot-password-form.component.scss',
})
export class ConfirmForgotPasswordFormComponent {
	@Output('onSubmit') public onSubmitEmitter: EventEmitter<any> = new EventEmitter<any>();
	@Output('onSwitchState') public onSwitchStateEmitter: EventEmitter<HomeState> = new EventEmitter<HomeState>();
	@Input('loading') public loading: boolean = false;

	public form: FormGroup;
	public readonly code = UrlHelper.queryString('code');
	public readonly source = Object.values(OneTimePasswordExchangeSource).find(
		source => source === UrlHelper.queryString('source')
	);

	constructor(private fb: FormBuilder) {
		this.form = this.fb.group(
			{
				password: ['', [...PasswordFieldComponent.validators, Validators.required]],
				confirmPassword: ['', [...PasswordFieldComponent.validators, Validators.required]],
			},
			{
				validator: ConfirmValidator('password', 'confirmPassword'),
			}
		);
	}

	onSubmit(): void {
		if (this.form.valid && this.code && this.source) {
			this.onSubmitEmitter.emit({
				code: this.code,
				source: this.source,
				newPassword: this.form.value.password,
			});
		}
	}

	clear(): void {
		this.form.reset();
	}

	public onBack() {
		this.onSwitchStateEmitter.emit(HomeState.LOGIN);
	}
}
